"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;
var _default = {
  isType: function isType(identifier) {
    if ("bytes" === identifier) return !0;
    var n = identifier.substr(5); // `byte` is bytes1

    return n || "byte" !== identifier || (identifier = "bytes1", n = 1), identifier.startsWith("bytes") && 32 >= n;
  },
  size: function size(identifier) {
    return "bytes" === identifier ? 1 / 0 : ("byte" === identifier && (identifier = "bytes1"), identifier.substr(5)); // `byte` is bytes1
  }
};
exports.default = _default;